window.sescBlockVideosOpenVideoModal = function (youtubeUrl) {
	// remove modal antigo se existir
	const oldModal = document.getElementById("videoModal");
	if (oldModal) {
		oldModal.remove();
	}

	const isMobile = window.matchMedia("(max-width: 767.98px)").matches;

	// cria o HTML do modal
	const modalHTML = `
        <div class="modal fade" id="videoModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl modal-fullscreen-md-down">
                <div class="modal-content bg-black">
                    <div class="modal-header border-0">
                        <button type="button" class="btn-close btn-close-white ms-auto" data-bs-dismiss="modal"></button>
                    </div>

                    <div class="modal-body p-0">
                        <div class="ratio ratio-16x9">
                            <iframe
                                src="${youtubeUrl}?autoplay=1${
																	isMobile ? "&playsinline=1" : ""
																}"
                                frameborder="0"
                                allow="autoplay; encrypted-media; picture-in-picture"
                                allowfullscreen>
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;

	// injeta no body
	document.body.insertAdjacentHTML("beforeend", modalHTML);

	const modalEl = document.getElementById("videoModal");
	const modal = new bootstrap.Modal(modalEl);

	// remove do DOM ao fechar
	modalEl.addEventListener("hidden.bs.modal", () => {
		modalEl.remove();
	});

	modal.show();
};

window.sescBlockVideosSetSizeVideos = function (idVideoContainer) {
	const containerVideo = document.getElementById(idVideoContainer);
	const video = containerVideo.querySelector("video");
	const contentVideo = containerVideo.querySelector(
		".sescblockvideo-content-video",
	);
	sescBlockVideosSetReSize(contentVideo, video);

	window.addEventListener("resize", function () {
		sescBlockVideosSetReSize(contentVideo, video);
	});
};

function sescBlockVideosSetReSize(contentVideo, video) {
	// const dataContainer = contentVideo.getBoundingClientRect();
	// const dataVideo = video.getBoundingClientRect();
	// if (dataContainer.width < dataContainer.height) {
	// 	console.log("regra a");
	// 	if (dataVideo.height < dataContainer.height) {
	// 		console.log("regra a1");
	// 		video.style.height = "100%";
	// 		video.style.width = "auto";
	// 	} else {
	// 		console.log("regra a2");
	// 		video.style.height = "auto";
	// 		video.style.width = "100%";
	// 	}
	// } else {
	// 	console.log("regra b");
	// 	if (dataVideo.width <= dataContainer.width) {
	// 		console.log("regra b1");
	// 		video.style.height = "auto";
	// 		video.style.width = "100%";
	// 	} else {
	// 		console.log("regra b2");
	// 		video.style.height = "100%";
	// 		video.style.width = "auto";
	// 	}
	// }
}

const handleDistorce = (value) => {
	const v = Math.max(-1, Math.min(1, value));
	let topOffset = 0;
	let bottomOffset = 100;

	topOffset = v < 0 ? Math.abs(v) * 20 : 0;
	bottomOffset = v * 20;

	topOffset = topOffset > 100 ? 100 : topOffset;
	bottomOffset = bottomOffset < 0 ? 0 : bottomOffset;

	if (invertDescktop) {
		return `polygon(0 0, ${100 - topOffset}% 0, ${
			100 - bottomOffset
		}% 100%, 0% 100%)`;
	}
	return `polygon(${topOffset}px 0, 100% 0, 100% 100%, ${bottomOffset}px 100%)`;
};
